module.exports = __webpack_public_path__ + "static/media/1001010HG.a6d321f3.jpg";